import { Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { SgAriaMessage } from '../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';
import { Sgkd004dSearchResultComponent } from '../components/sgkd004d-search-result/sgkd004d-search-result.component';
import { Sgkd016aResponseOutputinfo } from 'sg-api';

@Component({
  selector: 'app-sgkd004d',
  templateUrl: './sgkd004d.component.html',
  styleUrl: './sgkd004d.component.scss'
})
export class Sgkd004dComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  @Output() errorMessageModelArray: Array<SgAriaMessage> = [];

  @ViewChild(Sgkd004dSearchResultComponent) resultComponent: Sgkd004dSearchResultComponent;

  /** メインフォーム */
  mainForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd004dComponent
   */
  ngOnInit(): void {
    // メインフォームの生成
    this.mainForm = this.createMainForm();
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd004dComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * メインFormの生成
   * 
   * @returns - メインForm
   * @memberof Sgkd004dComponent
   */
  private createMainForm(): UntypedFormGroup {
    return this.formBuilder.group({});
  }

  /**
   * メッセージ領域のクリア
   * 
   * @memberof Sgkd004dComponent
   */
  clearMessage(): void {
    this.errorMessageModelArray = [];
  }

  /**
   * インフォメッセージのメッセージエリアモデル作成
   * 
   * @param info インフォメッセージ
   * @memberof Sgkd019dComponent
   */
  pushSgAriaMessage(message: string): void {
    this.errorMessageModelArray.push({
      message: message,
      messageClass: SgKdConstants.MESSAGE.INFO.MESSAGE_CLS,
      icon: SgKdConstants.MESSAGE.INFO.ICON,
      iconClass: SgKdConstants.MESSAGE.INFO.ICON_CLS,
    });
  }

  /**
   * 検索結果設定処理
   * 
   * @param resultList 検索結果
   * @memberof Sgkd004dComponent
   */
  setResult(resultList: Array<Sgkd016aResponseOutputinfo>) {
    this.resultComponent.setResult(resultList);
  }
}
